'use strict';

/**
 * New Relic agent configuration.
 *
 * See lib/config/default.js in the agent distribution for a more complete
 * description of configuration variables and their potential values.
 */
exports.config = {
  app_name: ['Olivela-Dev'],
  license_key: "adeb19fea5b242978dbf62850a3d37b3FFFFNRAL",
  logging: {
    level: 'info', // 'trace' is most useful to New Relic when diagnosing
    // issues, 'info' and higher will impose the least overhead on
    // production applications.
  },
  // This setting controls the agent's behavior in the browser.
  // Other configuration options...
};